module.exports = __webpack_public_path__ + "img/2_188.2aaede55.png";